/* Cosmic Escentuals — self-contained cart interactions.
   Bypasses the theme's native cart AJAX (which fails to re-render in-browser):
   - Add to cart: POST /cart/add.js, update the header count, show a toast — NO navigation.
   - Remove from cart: POST /cart/change.js (qty 0), then reload so totals + empty state are correct.
   Uses capture-phase listeners + stopImmediatePropagation so the theme's broken
   handlers never run. */
(function () {
  'use strict';
  if (window.__ceCartInit) return;
  window.__ceCartInit = true;

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'ce-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('ce-toast--in'); });
    setTimeout(function () {
      t.classList.remove('ce-toast--in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
    }, 2200);
  }

  /* ---------- header count bubble ---------- */
  function updateCount(count) {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        icon.appendChild(bubble);
      }
      bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>';
    } else if (bubble) {
      bubble.parentNode.removeChild(bubble);
    }
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isAddForm = action.indexOf('/cart/add') > -1 || (form.closest && form.closest('product-form'));
    if (!isAddForm) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[name="add"], [type="submit"]');
    var busy = btn && btn.getAttribute('aria-disabled') === 'true';
    if (busy) return;
    var label = btn ? btn.querySelector('span') : null;
    var prev = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (label) label.textContent = 'Adding…';

    var fd = new FormData(form);
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast((res.body && res.body.description) || 'Sorry, that could not be added.'); return null; }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCount(cart.item_count); toast('Added to bag'); });
      })
      .catch(function () { toast('Sorry, something went wrong.'); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        if (label) label.textContent = prev;
      });
  }, true);

  /* ---------- remove from cart (cart page) ---------- */
  document.addEventListener('click', function (e) {
    var rb = e.target.closest && e.target.closest('cart-remove-button, .cart-remove-button');
    if (!rb) return;

    var idxEl = (rb.matches && rb.matches('[data-index]')) ? rb
      : (rb.closest && rb.closest('[data-index]')) || (rb.querySelector && rb.querySelector('[data-index]'));
    var line = idxEl ? parseInt(idxEl.getAttribute('data-index'), 10) : NaN;
    if (!line) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    rb.style.opacity = '0.5';
    rb.style.pointerEvents = 'none';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }, true);

  /* ---------- quantity change (cart line items only) ---------- */
  var qtyTimer = null;
  function commitQty(line, qty) {
    clearTimeout(qtyTimer);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  // cart line quantity inputs carry name="updates[]" (product-page add qty uses name="quantity", so it's untouched)
  function cartQtyInput(el) {
    var wrap = el.closest && el.closest('quantity-input, .quantity');
    return wrap ? wrap.querySelector('input[name="updates[]"]') : null;
  }

  // +/- steppers (debounced so rapid clicks commit + reload once)
  document.addEventListener('click', function (e) {
    var qbtn = e.target.closest && e.target.closest('.quantity__button');
    if (!qbtn) return;
    var input = cartQtyInput(qbtn);
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var line = parseInt(input.getAttribute('data-index'), 10);
    if (!line) return;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var min = parseInt(input.getAttribute('data-min') || input.getAttribute('min') || '1', 10);
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : null;
    var current = parseInt(input.value, 10) || 0;
    var next = qbtn.getAttribute('name') === 'plus' ? current + step : current - step;
    if (max !== null && next > max) next = max;
    if (next < min) next = min; // stepper won't drop below min — use the trash icon to remove
    input.value = next;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () { commitQty(line, next); }, 600);
  }, true);

  // manual typing into the quantity field
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[name="updates[]"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var line = parseInt(input.getAttribute('data-index'), 10);
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    commitQty(line, qty);
  }, true);
})();
